module.exports = __webpack_public_path__ + "static/media/pay-cc.1cf51ce4.png";